import { serialize } from 'next-mdx-remote/serialize';

import { BlogContentSection } from 'components/blog/blog-content-section';
import { BlogHero } from 'components/blog/blog-hero';
import { BlogImageSection } from 'components/blog/blog-image-section';
import { BlogRelatedSection } from 'components/blog/blog-related-section';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchArticle, fetchRelatedArticles } from 'queries';
import { baseOptions } from 'utils/mdx';

const BlogDetailRoute = ({ ssr }) => {
	const article = ssr.article?.data || {};
	const articles = ssr.related?.data || [];

	// Render
	return (
		<article>
			<div className='hero-grid relative border-b py-14 md:py-20'>
				<div className='relative z-1 mx-auto max-w-md px-3'>
					<BlogHero article={article} />
				</div>
			</div>
			<div className='mx-auto px-3 max-w-md mt-10 md:mt-14'>
				<BlogImageSection article={article} />
			</div>
			<div className='mx-auto px-3 max-w-md mt-12 md:mt-16'>
				<BlogContentSection article={article} />
			</div>
			<div className='mx-auto px-3 max-w-xl'>
				<BlogRelatedSection article={article} articles={articles} />
			</div>
		</article>
	);
};

BlogDetailRoute.getLayout = (page, ssr) => {
	const article = ssr.article?.data || {};
	return (
		<BlogWrapper
			seo={{
				type: 'article',
				photo: process.env.NEXT_PUBLIC_BLOG_CLIENT + article.cover,
				description: article.description,
				author: article.owner?.name,
			}}>
			{page}
		</BlogWrapper>
	);
};
export async function getServerSideProps({ params }) {
	try {
		const [category, categoryId] = params?.slug;
		const article = await fetchArticle(category, categoryId);
		const related = await fetchRelatedArticles(category, categoryId, { params, query: { pageSize: 3 } });
		const content = await serialize(article.content, { mdxOptions: baseOptions as any });
		return { props: { article: { data: { ...article, content } }, related } };
	} catch (e) {
		console.error(e);
		return { notFound: true };
	}
}

export default BlogDetailRoute;
